export default __webpack_public_path__ + "static/media/logotext.d5aafea7.svg";